import * as React from "react";
import { DysplasiaList } from "../DysplasiaList";
import { ETLCodes } from "../../../locales";
import { ECommissionType } from "../../../api";

export interface IComissionGandDysplasiaListProps {}

export const ComissionGandDysplasiaList: React.FunctionComponent<IComissionGandDysplasiaListProps> = (props) => {
  return (
    <DysplasiaList
      isAppeal={false}
      breadcrumbText={ETLCodes.GentCommission}
      comissionType={ECommissionType.GentCommission}
    />
  );
};
